import { useLazyQuery } from '@apollo/client';
import { message } from 'antd';
import {
    GENERATE_PICKUP_TASK_DOWNLOAD_REPORT,
    GeneratePickupTaskReportResponse,
} from '../graphql/queries/generatePickupTaskDownloadReport';

/**
 * 揽收任务下载：提交异步任务，返回文件名供下载中心查找。
 * 与预约单下载同一套后端机制（ReportFile + S3），只是 reportType 不同。
 */
export function useGeneratePickupTaskReport() {
    const [generateReport, { loading }] = useLazyQuery<GeneratePickupTaskReportResponse>(
        GENERATE_PICKUP_TASK_DOWNLOAD_REPORT,
        { fetchPolicy: 'network-only' }
    );

    const submit = async (filter: Record<string, unknown>, timezone?: string | null) => {
        try {
            const { data } = await generateReport({ variables: { filter, timezone } });
            const fileName = data?.generatePickupTaskDownloadReport;
            if (!fileName) {
                message.error('Failed to start report generation task');
                return null;
            }
            return fileName;
        } catch (error: any) {
            // 超出下载上限时后端抛 BusinessException，message 里带了具体条数与建议
            message.error(error?.message || 'Failed to start report generation task');
            return null;
        }
    };

    return { submit, loading };
}
